import { SupportTicketStatus } from '@/hooks/useSupportChat';

export const statusLabelKey = (s: SupportTicketStatus) => `supportChat.status.${s}`;

export const statusBadgeClasses = (s: SupportTicketStatus) => {
  switch (s) {
    case 'bot':
      return 'bg-[#EBF4F8] text-[#0880AE] border border-[#0880AE]/30';
    case 'pending_admin':
      return 'bg-[#F2AC57]/15 text-[#D69440] border border-[#F2AC57]/40';
    case 'open':
      return 'bg-[#14A38B]/15 text-[#10836F] border border-[#14A38B]/40';
    case 'resolved':
      return 'bg-[#37699E]/15 text-[#37699E] border border-[#37699E]/40';
    case 'closed':
      return 'bg-[#DBE2EA] text-[#5A6B7A] border border-[#87ADD4]/40';
  }
};
